import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import React, { memo, useEffect, useState } from "react";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import { Grid } from "@material-ui/core";
import SearchAppointment from "./SearchAppointment";
import ListAppointment from "./ListAppointment";
import AppointmentListPopup from "app/PatientManagement/AppointmentList/Popup/AppointmentListPopup";
import { transformDate } from "app/common/LocalFunction";
import moment from "moment";
import * as Yup from "yup";
const AppointmentIndex = () => {
  const {
    searchAppointment,
    handleChangeFormSearchTab,
    resetStoreDetail,
    openFormCreateOrEdit,
    handleCloseCreateOrEditPopup,
    saveOrUpdateAppoint,
    initialAppointment,
  } = useStore().patientManagementStore.appointmentStore;
  const { handleGetPatientOverviewById } =
    useStore().patientManagementStore.patientGeneralStore;
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const defaultDepartment = useDefaultDepartment();
  useEffect(() => {
    if (patientId) {
      handleChangeFormSearchTab({
        ...searchAppointment,
        fromDate: null,
        toDate: null,
        // departmentId: defaultDepartment,
        patientId,
      });
    }
    return () => resetStoreDetail();
  }, [patientId, defaultDepartment]);

  const searchPatientValidationSchema = Yup.object().shape({
    fromDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày bắt đầu không đúng định dạng!")
      .test(
        "from-before-to",
        "Ngày bắt đầu không được lớn hơn ngày kết thúc!",
        function (from) {
          const { toDate } = this.parent;
          if (
            from &&
            toDate &&
            moment(from).isValid() &&
            moment(toDate).isValid()
          ) {
            return moment(from).isSameOrBefore(moment(toDate));
          }
          return true;
        }
      )
      .nullable(),

    toDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày kết thúc không đúng định dạng!")
      .test(
        "to-after-from",
        "Ngày kết thúc không được nhỏ hơn ngày bắt đầu!",
        function (to) {
          const { fromDate } = this.parent;
          if (
            fromDate &&
            to &&
            moment(fromDate).isValid() &&
            moment(to).isValid()
          ) {
            return moment(to).isSameOrAfter(moment(fromDate));
          }
          return true;
        }
      )
      .nullable(),
  });
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Formik
          initialValues={searchAppointment}
          validationSchema={searchPatientValidationSchema}
          onSubmit={(values) => {
            handleChangeFormSearchTab(values);
          }}
          enableReinitialize
        >
          <Form autoComplete="off">
            <SearchAppointment />
            <ListAppointment />
            {/* {openConfirmDelete && (
              <ConfirmPopup
                open={openConfirmDelete}
                onClose={handleCloseConfirmDialog}
                text="Bạn có chắc chắn muốn hủy check in không ?"
                onConfirm={handleConfirmDeleteCheckIn}
              />
            )} */}
            {openFormCreateOrEdit && (
              <AppointmentListPopup
                open={openFormCreateOrEdit}
                handleClose={handleCloseCreateOrEditPopup}
                handleSubmit={async (values, { setSubmitting }) => {
                  await saveOrUpdateAppoint(values, { setSubmitting }, true);
                  setTimeout(() => {
                    handleGetPatientOverviewById(patientId);
                  }, 500);
                }}
                initialValues={initialAppointment}
              />
            )}
          </Form>
        </Formik>
      </Grid>
    </Grid>
  );
};

export default memo(observer(AppointmentIndex));
